// extracted by mini-css-extract-plugin
module.exports = {"container":"_1W1r4l","imageContainer":"_1859q1","image":"ARuSET","title":"_8p__ZG","description":"_2F9GCt","button":"_3G9o65"};